import { render } from "./CompetencyTabContent.vue?vue&type=template&id=48f47762&ts=true"
import script from "./CompetencyTabContent.vue?vue&type=script&lang=ts"
export * from "./CompetencyTabContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__